<script setup>
import {Link} from '@inertiajs/vue3'
import HeaderMenu from "./HeaderMenu.vue";
import {isTouchDevice, onClickHashLink} from "../../../Helpers/helper";
import {isNull, throttle} from "lodash";
import {inject, onMounted} from "vue";
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/vue";
let html = null;
let header = null;
let preHeader = null;
let mainHeader = null;
let oldScrollY = null;
let newScrollY = window.scrollY;
let headerTranslateY = 0;
let mainHeaderHeight = 0;
let preHeaderHeight = 0;

let getTheme = inject('getTheme');
let setTheme = inject('setTheme');

const calcHeader = () => {
    newScrollY = window.scrollY;

    if (html?.style?.overflow) { //попапами
        return true;
    }

    preHeaderHeight = preHeader.clientHeight;
    mainHeaderHeight = mainHeader.clientHeight + 1; //+ 1px header border bottom

    //calc class
    if ((newScrollY > (mainHeaderHeight + preHeaderHeight)) && !header.classList.contains('small')) {
        header.classList.add('small');
    } else if((newScrollY <= (mainHeaderHeight + preHeaderHeight)) && header.classList.contains('small')) {
        header.classList.remove('small')
    }

    const topAnimationStartOffset = isTouchDevice() ? 0 : preHeaderHeight;

    if (isNull(oldScrollY) || (newScrollY <= topAnimationStartOffset) || !header.classList.contains('inited')) {
        headerTranslateY = 0;
    } else {
        if (newScrollY !== oldScrollY) {
            if (isTouchDevice()) {
                if (newScrollY > oldScrollY) {
                    headerTranslateY = -mainHeaderHeight;
                } else {
                    headerTranslateY = 0;
                }
            } else {
                headerTranslateY = Math.max(Math.min(headerTranslateY-(newScrollY - oldScrollY), 0), -mainHeaderHeight);
            }
        }
    }

    header.style.transform = 'translate3d(0, ' + headerTranslateY + 'px, 0)';
    oldScrollY = window.scrollY;
}


onMounted(() => {
    html = document.querySelector('html');
    header = document.querySelector('header');
    preHeader = document.querySelector('.pre-header');
    mainHeader = document.querySelector('.main-header');
    calcHeader();
});

document.addEventListener('scroll', throttle(() => {
    calcHeader();

    if (window.scrollY && !header.classList.contains('inited')) {
        header.classList.add('inited');
    }
}, 8), false);
</script>

<template>
    <div class="pre-header pt-2 md:pt-4 lg:pt-8 xl:pt-14"></div>
    <header
        class="sticky top-0 border-b border-transparent z-20 will-change-transform"
        :class="{touch: isTouchDevice()}"
    >
        <div class="main-header max-w-full w-[1536px] mx-auto px-6 flex justify-between">
            <Link href="/" class="logo flex items-start origin-left will-change-transform scale-[.85] lg:scale-100">
                <span class="flex-1 inline-block">
                    <span
                        class="title block pr-[.3rem] text-black dark:text-white text-3xl lg:text-5xl font-extrabold -tracking-[4.32px] leading-10 uppercase transition-transform duration-500">Quenta</span>
                    <span
                        class="subtitle block text-[.5rem] lg:text-xs font-medium text-right -mt-1 lg:mt-1 transition-transform">D&D gameapp</span>
                </span>
                <img src="/images/logo.png" alt="Quenta" loading="lazy"
                     class="flex-0 ml-2.5 mt-1 transition-transform duration-500 w-[40px] lg:w-[60px]"/>
            </Link>

            <nav
                class="top-nav flex-1 items-stretch text-black dark:text-white text-sm xl:text-lg uppercase font-bold ml-[11%] justify-between hidden lg:flex">
                <a href="/#main" class="link-underline !pt-6 xl:!pt-5 xl:px-4" @click="onClickHashLink"><span class="pointer-events-none">Что это?</span></a>
                <a href="/#player" class="link-underline !pt-6 xl:!pt-5 xl:px-4" @click="onClickHashLink"><span class="pointer-events-none">Игрокам</span></a>
                <a href="/#master" class="link-underline !pt-6 xl:!pt-5 xl:px-4" @click="onClickHashLink"><span class="pointer-events-none">Мастеру</span></a>
                <a href="/#features" class="link-underline !pt-6 xl:!pt-5 xl:px-4" @click="onClickHashLink"><span class="pointer-events-none">Будущее</span></a>
                <a href="/#subscribe" class="link-underline !pt-6 xl:!pt-5 xl:px-4" @click="onClickHashLink"><span class="pointer-events-none">Подписаться</span></a>
            </nav>

            <div class="hidden lg:flex items-center ml-3 pl-3 xl:ml-6 xl:pl-6">
                <Menu>
                    <MenuButton>
                        <label class="sr-only">Тема</label>
                        <span class="dark:hidden hover:opacity-80">
                                <svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                                    <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" class="stroke-current"></path>
                                    <path d="M12 4v1M17.66 6.344l-.828.828M20.005 12.004h-1M17.66 17.664l-.828-.828M12 20.01V19M6.34 17.664l.835-.836M3.995 12.004h1.01M6 6l.835.836" class="stroke-current"></path>
                                </svg>
                            </span>
                        <span class="hidden dark:inline hover:opacity-80">
                            <svg viewBox="0 0 24 24" fill="none" class="w-6 h-6">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.715 15.15A6.5 6.5 0 0 1 9 6.035C6.106 6.922 4 9.645 4 12.867c0 3.94 3.153 7.136 7.042 7.136 3.101 0 5.734-2.032 6.673-4.853Z" class="fill-transparent"></path>
                                <path d="m17.715 15.15.95.316a1 1 0 0 0-1.445-1.185l.495.869ZM9 6.035l.846.534a1 1 0 0 0-1.14-1.49L9 6.035Zm8.221 8.246a5.47 5.47 0 0 1-2.72.718v2a7.47 7.47 0 0 0 3.71-.98l-.99-1.738Zm-2.72.718A5.5 5.5 0 0 1 9 9.5H7a7.5 7.5 0 0 0 7.5 7.5v-2ZM9 9.5c0-1.079.31-2.082.845-2.93L8.153 5.5A7.47 7.47 0 0 0 7 9.5h2Zm-4 3.368C5 10.089 6.815 7.75 9.292 6.99L8.706 5.08C5.397 6.094 3 9.201 3 12.867h2Zm6.042 6.136C7.718 19.003 5 16.268 5 12.867H3c0 4.48 3.588 8.136 8.042 8.136v-2Zm5.725-4.17c-.81 2.433-3.074 4.17-5.725 4.17v2c3.552 0 6.553-2.327 7.622-5.537l-1.897-.632Z" class="fill-current"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17 3a1 1 0 0 1 1 1 2 2 0 0 0 2 2 1 1 0 1 1 0 2 2 2 0 0 0-2 2 1 1 0 1 1-2 0 2 2 0 0 0-2-2 1 1 0 1 1 0-2 2 2 0 0 0 2-2 1 1 0 0 1 1-1Z" class="fill-current"></path>
                            </svg>
                        </span>
                    </MenuButton>
                    <transition
                        enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0"
                        enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-in"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0"
                    >
                        <MenuItems class="absolute z-50 top-full right-2 bg-white rounded-lg ring-1 ring-slate-900/10 shadow-lg overflow-hidden w-36 py-1 text-sm font-semibold dark:bg-bg-dark-800 dark:ring-0 dark:highlight-white/5 mt-2 outline-none shadow-none">
                            <MenuItem v-slot="{ active }">
                                <li
                                    :class="[
                                        'py-1 px-2 flex items-center cursor-pointer',
                                        active || getTheme() === 'light' ? 'text-orange' : ''
                                    ]"
                                    @click="setTheme('light')"
                                >
                                    <svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round"
                                         stroke-linejoin="round" class="w-6 h-6 mr-2">
                                        <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                              class="stroke-current"></path>
                                        <path
                                            d="M12 4v1M17.66 6.344l-.828.828M20.005 12.004h-1M17.66 17.664l-.828-.828M12 20.01V19M6.34 17.664l.835-.836M3.995 12.004h1.01M6 6l.835.836"
                                            class="stroke-current"></path>
                                    </svg>
                                    Светлая
                                </li>

                            </MenuItem>
                            <MenuItem v-slot="{ active }">
                                <li
                                    :class="[
                                        'py-1 px-2 flex items-center cursor-pointer',
                                        active || getTheme() === 'dark' ? 'text-orange' : ''
                                    ]"
                                    @click="setTheme('dark')"
                                >
                                    <svg viewBox="0 0 24 24" fill="none" class="w-6 h-6 mr-2">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M17.715 15.15A6.5 6.5 0 0 1 9 6.035C6.106 6.922 4 9.645 4 12.867c0 3.94 3.153 7.136 7.042 7.136 3.101 0 5.734-2.032 6.673-4.853Z"
                                              class="fill-transparent"></path>
                                        <path
                                            d="m17.715 15.15.95.316a1 1 0 0 0-1.445-1.185l.495.869ZM9 6.035l.846.534a1 1 0 0 0-1.14-1.49L9 6.035Zm8.221 8.246a5.47 5.47 0 0 1-2.72.718v2a7.47 7.47 0 0 0 3.71-.98l-.99-1.738Zm-2.72.718A5.5 5.5 0 0 1 9 9.5H7a7.5 7.5 0 0 0 7.5 7.5v-2ZM9 9.5c0-1.079.31-2.082.845-2.93L8.153 5.5A7.47 7.47 0 0 0 7 9.5h2Zm-4 3.368C5 10.089 6.815 7.75 9.292 6.99L8.706 5.08C5.397 6.094 3 9.201 3 12.867h2Zm6.042 6.136C7.718 19.003 5 16.268 5 12.867H3c0 4.48 3.588 8.136 8.042 8.136v-2Zm5.725-4.17c-.81 2.433-3.074 4.17-5.725 4.17v2c3.552 0 6.553-2.327 7.622-5.537l-1.897-.632Z"
                                            class="fill-current"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M17 3a1 1 0 0 1 1 1 2 2 0 0 0 2 2 1 1 0 1 1 0 2 2 2 0 0 0-2 2 1 1 0 1 1-2 0 2 2 0 0 0-2-2 1 1 0 1 1 0-2 2 2 0 0 0 2-2 1 1 0 0 1 1-1Z"
                                              class="fill-current"></path>
                                    </svg>
                                    Темная
                                </li>
                            </MenuItem>
                            <MenuItem v-slot="{ active }">
                                <li
                                    :class="[
                                        'py-1 px-2 flex items-center cursor-pointer',
                                        active || getTheme() === 'system' ? 'text-orange' : ''
                                    ]"
                                    @click="setTheme('system')"
                                >
                                    <svg viewBox="0 0 24 24" fill="none" class="w-6 h-6 mr-2">
                                        <path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z"
                                              stroke-width="2" stroke-linejoin="round"
                                              class="stroke-current fill-current/20"></path>
                                        <path d="M14 15c0 3 2 5 2 5H8s2-2 2-5" stroke-width="2" stroke-linecap="round"
                                              stroke-linejoin="round" class="stroke-current"></path>
                                    </svg>
                                    Системная
                                </li>
                            </MenuItem>
                        </MenuItems>
                    </transition>
                </Menu>
            </div>

            <div class="flex items-center ml-2 lg:hidden">
                <HeaderMenu></HeaderMenu>
            </div>
        </div>
        <div class="sub-header">
            <slot name="subHeader"></slot>
        </div>
    </header>
</template>

<style lang="scss">
    .logo {
        &:hover {
            -webkit-mask-image: linear-gradient(-75deg, rgba(255,255,255, .9) 30%, rgba(0,0,0,0) 50%, rgba(255,255,255, .9) 70%);
            -webkit-mask-size: 200%;
            animation: shine 1s 1;
            animation-fill-mode: forwards;
        }

        @keyframes shine {
            from {
                -webkit-mask-position: 150%;
            }

            to {
                -webkit-mask-position: -50%;
            }
        }
    }

    header {
        &.inited {
            @apply duration-150;
            transition-property: padding, background, border, opacity;

            &.touch {
                @apply duration-300;
                transition-property: padding, background, border, opacity, transform;
            }

            .logo {
                @apply transition-transform duration-300;
            }
        }

        &.small {
            @apply border-slate-900/10 dark:border-slate-100/10 backdrop-blur bg-white/80 dark:bg-bg-dark/80;

            .logo {
                @apply scale-[.85];
            }
        }

        .main-header {
            transform: rotate3d(0,0,0,0)
        }
    }

    .page-guide header {
        @apply border-slate-900/10 dark:border-slate-100/10 lg:border-transparent dark:lg:border-transparent;

        &.small {
            @apply border-slate-900/10 dark:border-slate-100/10;
        }
    }
</style>
